export default function() {
  // Ensure footnotes start closed when opening the article.
  // There are some cases where classes like "*_is-clicked" or "*-text_is-clicked"
  // may be present; remove those so footnotes are collapsed by default.
  document
    .querySelectorAll('[id^="footnote-trigger-"], [id^="footnote-text-"]')
    .forEach((el) => {
      // Copy classList to avoid live mutation issues while iterating
      Array.from(el.classList).forEach((cls) => {
        if (/_is-clicked$/.test(cls) || /-text_is-clicked$/.test(cls)) {
          el.classList.remove(cls);
        }
      });
    });

  // Setup click event listeners for all footnote elements (triggers and text)
  for (let footNote of document.querySelectorAll('.js-foot-note')) {
    // Extract numeric id from element id (e.g. footnote-trigger-3 or footnote-text-3)
    let match = footNote.id.match(/\d+/);
    if (!match) continue;
    let id = +match[0];
    footNote.addEventListener('click', () => toggleFootNote(id, footNote.classList[0]));
  }
}

function toggleFootNote(id, base) {
  let trigger = document.querySelector(`#footnote-trigger-${id}`);
  let text = document.querySelector(`#footnote-text-${id}`);
  let end = base.substring(base.length - 4);
  let rest = base.slice(0, base.length - 5);

  if (end === 'text') {
    trigger.classList.toggle(`${rest}_is-clicked`);
    text.classList.toggle(`${base}_is-clicked`);
  } else {
    trigger.classList.toggle(`${base}_is-clicked`);
    text.classList.toggle(`${base}-text_is-clicked`);
  }
}
